import {
    ICadastrarHistoricoCasoVistoria,
    IGetHistoricoCasoVistoria,
} from "../../../Interfaces/VistoriaEntregaChaves/AcoesVistoria/AcoesVistoriaInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function GetHistoricoCasoVistoriaService(idCaso: number) {
    return Service(
        Axios.get<IGetHistoricoCasoVistoria>(
            `/vistoria/casovistoria/gethistoricocasovistoria?idCaso=${idCaso}`
        )
    );
}

export async function CadastrarHistoricoCasoVistoriaService(
    requestBody: ICadastrarHistoricoCasoVistoria
) {
    return Service(
        Axios.post(
            `/vistoria/casovistoria/cadastrarhistoricocasovistoria`,
            requestBody
        )
    );
}
